import React from 'react'

function GoogleMaps() {
  return (
    <div>
      <section className="google-map">
        <div
          className="wow fadeInUp animated"
          data-wow-duration="1500ms"
          data-wow-delay="100ms"
        >
          <iframe
            src="https://www.google.com/maps/embed/v1/place?q=New+York,+NY,+USA&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
            className="google-map-one"
          />
        </div>
      </section>
    </div>
  )
}

export default GoogleMaps
